// A ticket reflects the existing visit record, including a later revisit.
export function exhibitionTicketState(id, session = {}) {
  const visit = session.visits?.[id] || (session.lastView?.id === id ? session.lastView : null);
  if (visit?.completed || (!visit && session.completedViews?.includes(id))) {
    return { kind: 'complete', label: 'Visited', detail: visit?.completedAt ? new Intl.DateTimeFormat('en-GB',{day:'numeric',month:'short',year:'numeric'}).format(new Date(visit.completedAt)) : '' };
  }
  if (visit) {
    const room = visit.position?.sectionIndex;
    return { kind: 'started', label: 'Continue your visit', detail: Number.isInteger(room) && room >= 0 ? `Room ${String(room + 1).padStart(2, '0')}` : 'At the entrance' };
  }
  return { kind: 'new', label: 'Ready to visit', detail: '' };
}
export function exhibitionTicketNumber(id = '') {
  let value = 0;
  for (const character of id) value = (Math.imul(value, 31) + character.charCodeAt(0)) >>> 0;
  return String(value % 1000000).padStart(6, '0');
}
